module.exports = __webpack_public_path__ + "img/services_target1.caeff655.png";